import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=2dcf0d2a&scoped=true&"
import script from "./Photos.vue?vue&type=script&lang=ts&"
export * from "./Photos.vue?vue&type=script&lang=ts&"
import style0 from "./Photos.vue?vue&type=style&index=0&id=2dcf0d2a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcf0d2a",
  null
  
)

export default component.exports